import { foldVerificationStatus } from "../verdict-law.js";
const workItemTransitions = {
    draft: ["ready", "cancelled"],
    ready: ["running", "blocked", "cancelled"],
    running: ["blocked", "completed", "cancelled"],
    blocked: ["ready", "cancelled"],
    completed: [],
    cancelled: [],
};
const workAttemptTransitions = {
    queued: ["running", "cancelled"],
    running: ["succeeded", "failed", "cancelled"],
    succeeded: [],
    failed: [],
    cancelled: [],
};
const manifestTransitions = {
    planned: ["running"],
    running: ["determined"],
    determined: ["reviewed", "sealed"],
    reviewed: ["sealed"],
    sealed: [],
};
export function canTransitionWorkItem(from, to) {
    return workItemTransitions[from].includes(to);
}
export function canTransitionWorkAttempt(from, to) {
    return workAttemptTransitions[from].includes(to);
}
export function canTransitionRunManifest(from, to) {
    return manifestTransitions[from].includes(to);
}
/**
 * The fold over checks that carry evaluator authority. This tier's law — the
 * NOT_RUN -> UNKNOWN promotion plus the PASS authority floor — is the one the
 * whole system now uses; it lives in `verdict-law.ts` and every other
 * aggregation site reads it from there.
 */
export function aggregateVerificationStatus(checks) {
    return foldVerificationStatus(checks);
}
